import React from "react";
import ShipmentUpdateCard from "../ShipmentUpdateCard/ShipmentUpdateCard";
import "./ShipmentUpdateElements.scss";
import { Button } from "antd";
import { receiveTrackingNotification } from "../../../services/shipments";

const ShipmentUpdateElements = ({updates, refetch}) => {
  
  function handleReceivedAll() {
    const updateIds = updates?.map((u) => u.id)
    if(updateIds.length){
      receiveTrackingNotification(updateIds);
      refetch();
    }
  }

  return (
    <div className="ShipmentUpdateElements">
      <div className="received-btn">
        <Button className="link-btn" onClick={handleReceivedAll}>All Received</Button>
      </div>
      <div className="elements-wrapper">
        {
          updates && updates.map((u) => <ShipmentUpdateCard key={u.id} update={u} refetch={refetch}/>)
        }
      </div>
    </div>
  )
}

export default ShipmentUpdateElements;
